import { render, staticRenderFns } from "./orderScanner.vue?vue&type=template&id=1af3add8&"
import script from "./orderScanner.vue?vue&type=script&lang=js&"
export * from "./orderScanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports